import { PickerModel } from "../models/PickerModel";

export const ContentLanguages: PickerModel[] = [
  {
    key: "English",
    title: "🇬🇧 English",
    value: "0",
  },
  {
    key: "Turkish",
    title: "🇹🇷 Turkish",
    value: "1",
  },
  {
    key: "Spanish",
    title: "🇪🇸 Spanish",
    value: "2",
  },
  {
    key: "Portuguese",
    title: "🇵🇹 Portuguese",
    value: "3",
  },
  {
    key: "German",
    title: "🇩🇪 German",
    value: "4",
  },
  {
    key: "French",
    title: "🇫🇷 French",
    value: "5",
  },
  {
    key: "Russian",
    title: "🇷🇺 Russian",
    value: "6",
  }
];
